(() => {
  window.swinger.eventHub.register('click', '.swinger-consent__allow-none', (e) => {
    const form = window.swinger.eventHub.getTarget(e).closest('form');
    const checkboxes = window.swinger.$('input[type="checkbox"]', form);

    checkboxes.forEach((checkbox) => { checkbox.checked = false; });
  });

  window.swinger.eventHub.register('click', '.swinger-consent__allow-all', (e) => {
    const form = window.swinger.eventHub.getTarget(e).closest('form');
    const checkboxes = window.swinger.$('input[type="checkbox"]', form);

    checkboxes.forEach((checkbox) => { checkbox.checked = true; });
  });

  window.swinger.eventHub.register('submit', '.swinger-consent form', (e) => {
    window.requestAnimationFrame(() => {
      const form = window.swinger.eventHub.getTarget(e);
      const checkboxes = window.swinger.$('input[type="checkbox"]', form);
      // eslint-disable-next-line no-confusing-arrow
      const cookieValue = checkboxes.map((checkbox) => checkbox.checked ? checkbox.value : '').join(' ');

      window.swinger.cookie.set('consent', cookieValue);
      form.closest('.swinger-consent').style.display = 'none';
    });

    e.preventDefault();
  });
})();
